<script setup lang="ts">
import { computed } from 'vue';
import { UiText, UiTextarea } from '@shopexperts/shared';
import { CLAIM_NOTE_MAX_LENGTH, isClaimNoteOverLimit } from './claimAppearance';

const props = defineProps<{
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
}>();

const model = defineModel<string>({ default: '' });

const isOverLimit = computed(() => isClaimNoteOverLimit(model.value));
</script>

<template>
  <div class="flex flex-col gap-1">
    <UiText v-if="props.label" as="label" variant="h6" :text="props.label" />
    <UiTextarea
      v-model="model"
      :placeholder="props.placeholder"
      :rows="props.rows ?? 4"
      :disabled="props.disabled"
      :invalid="isOverLimit"
      :error="isOverLimit ? `Notes are limited to ${CLAIM_NOTE_MAX_LENGTH.toLocaleString()} characters.` : undefined"
    />
    <UiText
      as="p"
      variant="caption-normal"
      class="text-right"
      :class="isOverLimit ? 'text-rose-600' : 'text-gray-400'"
      :text="`${model.length.toLocaleString()} / ${CLAIM_NOTE_MAX_LENGTH.toLocaleString()}`"
    />
  </div>
</template>
